import type { TooltipProps } from '@bos/ui';
import { Tooltip } from '@bos/ui';

export type AppBaseTooltipProps = TooltipProps;

/** Use AppTooltip instead of AppBaseTooltip, it should be used only within packages like mobility-ui */
export const AppBaseTooltip = (props: AppBaseTooltipProps) => (
	<Tooltip {...props} />
);
